// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/rolodex/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        handleRequestHealthReadinessGet: build.query<HandleRequestHealthReadinessGetApiResponse, HandleRequestHealthReadinessGetApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        handleRequestHealthLivenessGet: build.query<HandleRequestHealthLivenessGetApiResponse, HandleRequestHealthLivenessGetApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        handleRequestPingGet: build.query<HandleRequestPingGetApiResponse, HandleRequestPingGetApiArg>({
            query: () => ({ url: `/ping` }),
        }),
        metricsMetricsGet: build.query<MetricsMetricsGetApiResponse, MetricsMetricsGetApiArg>({
            query: () => ({ url: `/metrics` }),
        }),
        queueClientDeletionApiV1ClientDeletionPost: build.mutation<QueueClientDeletionApiV1ClientDeletionPostApiResponse, QueueClientDeletionApiV1ClientDeletionPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-deletion`,
                method: "POST",
                body: queryArg.queueClientDeletionRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cancelClientDeletionApiV1ClientDeletionClientIdDelete: build.mutation<CancelClientDeletionApiV1ClientDeletionClientIdDeleteApiResponse, CancelClientDeletionApiV1ClientDeletionClientIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-deletion/${queryArg.clientId}`,
                method: "DELETE",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientMappingApiV1ClientMappingGet: build.query<GetClientMappingApiV1ClientMappingGetApiResponse, GetClientMappingApiV1ClientMappingGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGet: build.query<GetWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGetApiResponse, GetWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping/workday/environments`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGet: build.query<GetWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGetApiResponse, GetWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping/workday/environments/${queryArg.tenantId}/${queryArg.tenantEnvironment}`,
                params: {
                    cps_host: queryArg.cpsHost,
                    galahad_host: queryArg.galahadHost,
                    suv_id: queryArg.suvId,
                    skip_csrf: queryArg.skipCsrf,
                    internal: queryArg.internal,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        refreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPost: build.mutation<RefreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPostApiResponse, RefreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping/${queryArg.pilotClientId}/workday/refresh-hosts`,
                method: "POST",
                params: {
                    cps_host: queryArg.cpsHost,
                    galahad_host: queryArg.galahadHost,
                    skip_csrf: queryArg.skipCsrf,
                    internal: queryArg.internal,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        refreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPost: build.mutation<RefreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPostApiResponse, RefreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping/${queryArg.pilotClientId}/workday/refresh-registration`,
                method: "POST",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientMappingByIdApiV1ClientMappingPilotClientIdGet: build.query<GetClientMappingByIdApiV1ClientMappingPilotClientIdGetApiResponse, GetClientMappingByIdApiV1ClientMappingPilotClientIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client-mapping/${queryArg.pilotClientId}`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        authorizeApiV1OauthAuthorizeGet: build.query<AuthorizeApiV1OauthAuthorizeGetApiResponse, AuthorizeApiV1OauthAuthorizeGetApiArg>({
            query: () => ({ url: `/api/v1/oauth/authorize` }),
        }),
        issueTokenApiV1OauthTokenPost: build.mutation<IssueTokenApiV1OauthTokenPostApiResponse, IssueTokenApiV1OauthTokenPostApiArg>({
            query: () => ({ url: `/api/v1/oauth/token`, method: "POST" }),
        }),
        revokeTokenApiV1OauthRevokePost: build.mutation<RevokeTokenApiV1OauthRevokePostApiResponse, RevokeTokenApiV1OauthRevokePostApiArg>({
            query: () => ({ url: `/api/v1/oauth/revoke`, method: "POST" }),
        }),
        userinfoApiV1OauthUserinfoGet: build.query<UserinfoApiV1OauthUserinfoGetApiResponse, UserinfoApiV1OauthUserinfoGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/userinfo`,
                params: { internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        registerClientApiV1OauthClientsPost: build.mutation<RegisterClientApiV1OauthClientsPostApiResponse, RegisterClientApiV1OauthClientsPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/clients`,
                method: "POST",
                body: queryArg.oAuthClientCreateRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listClientsApiV1OauthClientsGet: build.query<ListClientsApiV1OauthClientsGetApiResponse, ListClientsApiV1OauthClientsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/clients`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientApiV1OauthClientsOauthClientIdGet: build.query<GetClientApiV1OauthClientsOauthClientIdGetApiResponse, GetClientApiV1OauthClientsOauthClientIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/clients/${queryArg.oauthClientId}`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateClientApiV1OauthClientsOauthClientIdPut: build.mutation<UpdateClientApiV1OauthClientsOauthClientIdPutApiResponse, UpdateClientApiV1OauthClientsOauthClientIdPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/clients/${queryArg.oauthClientId}`,
                method: "PUT",
                body: queryArg.oAuthClientUpdateRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteClientApiV1OauthClientsOauthClientIdDelete: build.mutation<DeleteClientApiV1OauthClientsOauthClientIdDeleteApiResponse, DeleteClientApiV1OauthClientsOauthClientIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oauth/clients/${queryArg.oauthClientId}`,
                method: "DELETE",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        jwksApiV1OauthWellKnownJwksJsonGet: build.query<JwksApiV1OauthWellKnownJwksJsonGetApiResponse, JwksApiV1OauthWellKnownJwksJsonGetApiArg>({
            query: () => ({ url: `/api/v1/oauth/.well-known/jwks.json` }),
        }),
        oidcCallbackApiV1OidcCallbackGet: build.query<OidcCallbackApiV1OidcCallbackGetApiResponse, OidcCallbackApiV1OidcCallbackGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oidc/callback`,
                params: {
                    id: queryArg.id,
                    code: queryArg.code,
                    tenant_id: queryArg.tenantId,
                    tenant_environment: queryArg.tenantEnvironment,
                    suv_id: queryArg.suvId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getOidcConfigApiV1OidcPilotClientSubdomainGet: build.query<GetOidcConfigApiV1OidcPilotClientSubdomainGetApiResponse, GetOidcConfigApiV1OidcPilotClientSubdomainGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/oidc/${queryArg.pilotClientSubdomain}`,
                params: { return_url: queryArg.returnUrl },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        passwordAuthenticateApiV1ProxyPasswordsAuthenticatePost: build.mutation<PasswordAuthenticateApiV1ProxyPasswordsAuthenticatePostApiResponse, PasswordAuthenticateApiV1ProxyPasswordsAuthenticatePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/proxy/passwords/authenticate`,
                method: "POST",
                body: queryArg.passwordLoginRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        setPasswordApiV1ProxyPasswordPost: build.mutation<SetPasswordApiV1ProxyPasswordPostApiResponse, SetPasswordApiV1ProxyPasswordPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/proxy/password`,
                method: "POST",
                body: queryArg.passwordSetRequest,
                params: {
                    token_type: queryArg.tokenType,
                    token: queryArg.token,
                    slug: queryArg.slug,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        tokenAuthenticateApiV1ProxyTokenAuthenticateGet: build.query<TokenAuthenticateApiV1ProxyTokenAuthenticateGetApiResponse, TokenAuthenticateApiV1ProxyTokenAuthenticateGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/proxy/token/authenticate`,
                params: {
                    stytch_token_type: queryArg.stytchTokenType,
                    token: queryArg.token,
                    slug: queryArg.slug,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        idleSignOutApiV1ProxyIdleSignOutPost: build.mutation<IdleSignOutApiV1ProxyIdleSignOutPostApiResponse, IdleSignOutApiV1ProxyIdleSignOutPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/proxy/idle-sign-out`,
                method: "POST",
                cookies: { session_token: queryArg.sessionToken },
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        evisortInitSignOutApiV1ProxySignOutPost: build.mutation<EvisortInitSignOutApiV1ProxySignOutPostApiResponse, EvisortInitSignOutApiV1ProxySignOutPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/proxy/sign-out`,
                method: "POST",
                cookies: { session_token: queryArg.sessionToken },
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGet: build.query<GetClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGetApiResponse, GetClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/public/auth-configs/${queryArg.pilotClientSubdomain}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        pusherAuthApiV1PusherAuthPost: build.mutation<PusherAuthApiV1PusherAuthPostApiResponse, PusherAuthApiV1PusherAuthPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/pusher/auth`,
                method: "POST",
                body: queryArg.bodyPusherAuthApiV1PusherAuthPost,
                cookies: {
                    session_jwt: queryArg.sessionJwt,
                    session_token: queryArg.sessionToken,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSmalConfigInfoApiV1SamlConfigInfoGet: build.query<GetSmalConfigInfoApiV1SamlConfigInfoGetApiResponse, GetSmalConfigInfoApiV1SamlConfigInfoGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/config-info`,
                params: {
                    client: queryArg.client,
                    skip_csrf: queryArg.skipCsrf,
                    internal: queryArg.internal,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientSamlConfigsApiV1SamlConfigsPilotClientIdGet: build.query<GetClientSamlConfigsApiV1SamlConfigsPilotClientIdGetApiResponse, GetClientSamlConfigsApiV1SamlConfigsPilotClientIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/configs/${queryArg.pilotClientId}`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGet: build.query<GetClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGetApiResponse, GetClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/config/${queryArg.pilotClientId}/${queryArg.configUuid}`,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPut: build.mutation<CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPutApiResponse, CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/config/${queryArg.pilotClientId}/${queryArg.configUuid}`,
                method: "PUT",
                body: queryArg.createSamlConfigRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDelete: build.mutation<DeleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDeleteApiResponse, DeleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/config/${queryArg.pilotClientId}/${queryArg.configUuid}`,
                method: "DELETE",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPost: build.mutation<CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPostApiResponse, CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/saml/config/${queryArg.pilotClientId}`,
                method: "POST",
                body: queryArg.createSamlConfigRequest,
                params: {
                    config_uuid: queryArg.configUuid,
                    skip_csrf: queryArg.skipCsrf,
                    internal: queryArg.internal,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        csrfTokenApiV1TokenCsrfGet: build.query<CsrfTokenApiV1TokenCsrfGetApiResponse, CsrfTokenApiV1TokenCsrfGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/token/csrf`,
                cookies: {
                    session_jwt: queryArg.sessionJwt,
                    session_token: queryArg.sessionToken,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        tokenVerifyApiV1TokenVerifyPost: build.mutation<TokenVerifyApiV1TokenVerifyPostApiResponse, TokenVerifyApiV1TokenVerifyPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/token/verify`,
                method: "POST",
                body: queryArg.tokenVerifyRequest,
                headers: { "x-csrftoken": queryArg["x-csrftoken"] },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        tokenRefreshApiV1TokenRefreshPost: build.mutation<TokenRefreshApiV1TokenRefreshPostApiResponse, TokenRefreshApiV1TokenRefreshPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/token/refresh`,
                method: "POST",
                cookies: { session_token: queryArg.sessionToken },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSelfApiV1UserSelfGet: build.query<GetSelfApiV1UserSelfGetApiResponse, GetSelfApiV1UserSelfGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/self`,
                params: { skip_csrf: queryArg.skipCsrf },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientUsersApiV1UserGet: build.query<GetClientUsersApiV1UserGetApiResponse, GetClientUsersApiV1UserGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user`,
                params: {
                    uuid: queryArg.uuid,
                    id: queryArg.id,
                    email: queryArg.email,
                    status: queryArg.status,
                    roles: queryArg.roles,
                    departments: queryArg.departments,
                    searchValue: queryArg.searchValue,
                    limit: queryArg.limit,
                    offset: queryArg.offset,
                    client_id: queryArg.clientId,
                    skip_csrf: queryArg.skipCsrf,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createUserApiV1UserCreatePost: build.mutation<CreateUserApiV1UserCreatePostApiResponse, CreateUserApiV1UserCreatePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/create`,
                method: "POST",
                body: queryArg.createOrUpdateUserRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateUserApiV1UserPilotUserIdPut: build.mutation<UpdateUserApiV1UserPilotUserIdPutApiResponse, UpdateUserApiV1UserPilotUserIdPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/${queryArg.pilotUserId}`,
                method: "PUT",
                body: queryArg.createOrUpdateUserRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteUserApiV1UserDeleteUserIdDelete: build.mutation<DeleteUserApiV1UserDeleteUserIdDeleteApiResponse, DeleteUserApiV1UserDeleteUserIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/delete/${queryArg.userId}`,
                method: "DELETE",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        sendInviteUserApiV1UserSendInviteUserIdPatch: build.mutation<SendInviteUserApiV1UserSendInviteUserIdPatchApiResponse, SendInviteUserApiV1UserSendInviteUserIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/send-invite/${queryArg.userId}`,
                method: "PATCH",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        restoreUserApiV1UserRestoreUserIdPatch: build.mutation<RestoreUserApiV1UserRestoreUserIdPatchApiResponse, RestoreUserApiV1UserRestoreUserIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/restore/${queryArg.userId}`,
                method: "PATCH",
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkdayUserApiV1UserWorkdayUserIdPut: build.mutation<UpdateWorkdayUserApiV1UserWorkdayUserIdPutApiResponse, UpdateWorkdayUserApiV1UserWorkdayUserIdPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/workday/${queryArg.userId}`,
                method: "PUT",
                body: queryArg.updateWorkdayUserRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkdayUserApiV1UserExternalUserIdPut: build.mutation<UpdateWorkdayUserApiV1UserExternalUserIdPutApiResponse, UpdateWorkdayUserApiV1UserExternalUserIdPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/external/${queryArg.userId}`,
                method: "PUT",
                body: queryArg.updateWorkdayUserRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPreferenceApiV1UserPreferencesContextKeyGet: build.query<GetPreferenceApiV1UserPreferencesContextKeyGetApiResponse, GetPreferenceApiV1UserPreferencesContextKeyGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/preferences/${queryArg.context}/${queryArg.key}`,
                params: { skip_csrf: queryArg.skipCsrf },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        setPreferenceApiV1UserPreferencesContextKeyPut: build.mutation<SetPreferenceApiV1UserPreferencesContextKeyPutApiResponse, SetPreferenceApiV1UserPreferencesContextKeyPutApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/preferences/${queryArg.context}/${queryArg.key}`,
                method: "PUT",
                body: queryArg.setUserPreferenceRequest,
                params: { skip_csrf: queryArg.skipCsrf, internal: queryArg.internal },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listPreferencesApiV1UserPreferencesContextGet: build.query<ListPreferencesApiV1UserPreferencesContextGetApiResponse, ListPreferencesApiV1UserPreferencesContextGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/user/preferences/${queryArg.context}`,
                params: { skip_csrf: queryArg.skipCsrf },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        openidConfigurationWellKnownOpenidConfigurationGet: build.query<OpenidConfigurationWellKnownOpenidConfigurationGetApiResponse, OpenidConfigurationWellKnownOpenidConfigurationGetApiArg>({
            query: () => ({ url: `/.well-known/openid-configuration` }),
        }),
        sessionJwksWellKnownJwksJsonGet: build.query<SessionJwksWellKnownJwksJsonGetApiResponse, SessionJwksWellKnownJwksJsonGetApiArg>({
            query: () => ({ url: `/.well-known/jwks.json` }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type HandleRequestHealthReadinessGetApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type HandleRequestHealthReadinessGetApiArg = void;
export type HandleRequestHealthLivenessGetApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type HandleRequestHealthLivenessGetApiArg = void;
export type HandleRequestPingGetApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type HandleRequestPingGetApiArg = void;
export type MetricsMetricsGetApiResponse = 
/** status 200 Successful Response */ any;
export type MetricsMetricsGetApiArg = void;
export type QueueClientDeletionApiV1ClientDeletionPostApiResponse = 
/** status 200 Successful Response */ ClientDeletionQueuedResponse;
export type QueueClientDeletionApiV1ClientDeletionPostApiArg = {
    skipCsrf?: boolean;
    internal?: any;
    queueClientDeletionRequest: QueueClientDeletionRequest;
};
export type CancelClientDeletionApiV1ClientDeletionClientIdDeleteApiResponse = 
/** status 200 Successful Response */ ClientDeletionCancelledResponse;
export type CancelClientDeletionApiV1ClientDeletionClientIdDeleteApiArg = {
    clientId: number;
    skipCsrf?: boolean;
    internal?: any;
};
export type GetClientMappingApiV1ClientMappingGetApiResponse = 
/** status 200 Successful Response */ ClientMapping;
export type GetClientMappingApiV1ClientMappingGetApiArg = {
    skipCsrf?: boolean;
    internal?: any;
};
export type GetWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGetApiResponse = 
/** status 200 Successful Response */ WorkdayEnvironmentNode[];
export type GetWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGetApiArg = {
    skipCsrf?: boolean;
    internal?: any;
};
export type GetWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGetApiResponse = 
/** status 200 Successful Response */ WorkdayEnvironmentNode;
export type GetWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGetApiArg = {
    tenantEnvironment: WorkdayEnvironment;
    tenantId: string;
    cpsHost?: string | null;
    galahadHost?: string | null;
    suvId?: string | null;
    skipCsrf?: boolean;
    internal?: any;
};
export type RefreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPostApiResponse = 
/** status 200 Successful Response */ WorkdayEnvironmentNode;
export type RefreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPostApiArg = {
    pilotClientId: number;
    cpsHost?: string | null;
    galahadHost?: string | null;
    skipCsrf?: boolean;
    internal?: any;
};
export type RefreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPostApiResponse = 
/** status 200 Successful Response */ CpsFuguRegistrationResult;
export type RefreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPostApiArg = {
    pilotClientId: number;
    skipCsrf?: boolean;
    internal?: any;
};
export type GetClientMappingByIdApiV1ClientMappingPilotClientIdGetApiResponse = 
/** status 200 Successful Response */ ClientMapping;
export type GetClientMappingByIdApiV1ClientMappingPilotClientIdGetApiArg = {
    pilotClientId: number;
    skipCsrf?: boolean;
    internal?: any;
};
export type AuthorizeApiV1OauthAuthorizeGetApiResponse = 
/** status 200 Successful Response */ any;
export type AuthorizeApiV1OauthAuthorizeGetApiArg = void;
export type IssueTokenApiV1OauthTokenPostApiResponse = 
/** status 200 Successful Response */ any;
export type IssueTokenApiV1OauthTokenPostApiArg = void;
export type RevokeTokenApiV1OauthRevokePostApiResponse = 
/** status 200 Successful Response */ any;
export type RevokeTokenApiV1OauthRevokePostApiArg = void;
export type UserinfoApiV1OauthUserinfoGetApiResponse = 
/** status 200 Successful Response */ any;
export type UserinfoApiV1OauthUserinfoGetApiArg = {
    internal?: any;
};
export type RegisterClientApiV1OauthClientsPostApiResponse = 
/** status 201 Successful Response */ OAuthClientCreateResponse;
export type RegisterClientApiV1OauthClientsPostApiArg = {
    skipCsrf?: boolean;
    internal?: any;
    oAuthClientCreateRequest: OAuthClientCreateRequest;
};
export type ListClientsApiV1OauthClientsGetApiResponse = 
/** status 200 Successful Response */ OAuthClientResponse[];
export type ListClientsApiV1OauthClientsGetApiArg = {
    skipCsrf?: boolean;
    internal?: any;
};
export type GetClientApiV1OauthClientsOauthClientIdGetApiResponse = 
/** status 200 Successful Response */ OAuthClientResponse;
export type GetClientApiV1OauthClientsOauthClientIdGetApiArg = {
    oauthClientId: string;
    skipCsrf?: boolean;
    internal?: any;
};
export type UpdateClientApiV1OauthClientsOauthClientIdPutApiResponse = 
/** status 200 Successful Response */ OAuthClientResponse;
export type UpdateClientApiV1OauthClientsOauthClientIdPutApiArg = {
    oauthClientId: string;
    skipCsrf?: boolean;
    internal?: any;
    oAuthClientUpdateRequest: OAuthClientUpdateRequest;
};
export type DeleteClientApiV1OauthClientsOauthClientIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteClientApiV1OauthClientsOauthClientIdDeleteApiArg = {
    oauthClientId: string;
    skipCsrf?: boolean;
    internal?: any;
};
export type JwksApiV1OauthWellKnownJwksJsonGetApiResponse = 
/** status 200 Successful Response */ any;
export type JwksApiV1OauthWellKnownJwksJsonGetApiArg = void;
export type OidcCallbackApiV1OidcCallbackGetApiResponse = 
/** status 200 Successful Response */ any;
export type OidcCallbackApiV1OidcCallbackGetApiArg = {
    /** Token UUID received from Evi2Ken */
    id: string;
    /** One-time code received from Evi2Ken */
    code: string;
    /** Workday tenant ID from Evi2Ken */
    tenantId?: string | null;
    /** Workday tenant environment from Evi2Ken */
    tenantEnvironment?: string | null;
    /** Workday SUV ID from Evi2Ken */
    suvId?: string | null;
};
export type GetOidcConfigApiV1OidcPilotClientSubdomainGetApiResponse = 
/** status 200 Successful Response */ any;
export type GetOidcConfigApiV1OidcPilotClientSubdomainGetApiArg = {
    pilotClientSubdomain: string;
    /** URL to redirect to after successful authentication */
    returnUrl?: string | null;
};
export type PasswordAuthenticateApiV1ProxyPasswordsAuthenticatePostApiResponse = 
/** status 200 Successful Response */ AuthenticateResponse;
export type PasswordAuthenticateApiV1ProxyPasswordsAuthenticatePostApiArg = {
    passwordLoginRequest: PasswordLoginRequest;
};
export type SetPasswordApiV1ProxyPasswordPostApiResponse = 
/** status 200 Successful Response */ any;
export type SetPasswordApiV1ProxyPasswordPostApiArg = {
    tokenType?: StytchTokenType;
    token?: string;
    slug?: string;
    passwordSetRequest: PasswordSetRequest;
};
export type TokenAuthenticateApiV1ProxyTokenAuthenticateGetApiResponse = 
/** status 200 Successful Response */ any;
export type TokenAuthenticateApiV1ProxyTokenAuthenticateGetApiArg = {
    stytchTokenType?: StytchTokenType;
    token?: string;
    slug?: string;
};
export type IdleSignOutApiV1ProxyIdleSignOutPostApiResponse = 
/** status 200 Successful Response */ any;
export type IdleSignOutApiV1ProxyIdleSignOutPostApiArg = {
    skipCsrf?: boolean;
    internal?: any;
    sessionToken: string;
};
export type EvisortInitSignOutApiV1ProxySignOutPostApiResponse = 
/** status 200 Successful Response */ any;
export type EvisortInitSignOutApiV1ProxySignOutPostApiArg = {
    skipCsrf?: boolean;
    internal?: any;
    sessionToken: string;
};
export type GetClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGetApiResponse = 
/** status 200 Successful Response */ ClientAuthConfigsResponse;
export type GetClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGetApiArg = {
    pilotClientSubdomain: string;
};
export type PusherAuthApiV1PusherAuthPostApiResponse = 
/** status 200 Successful Response */ any;
export type PusherAuthApiV1PusherAuthPostApiArg = {
    sessionJwt?: string | null;
    sessionToken?: string | null;
    bodyPusherAuthApiV1PusherAuthPost: BodyPusherAuthApiV1PusherAuthPost;
};
export type GetSmalConfigInfoApiV1SamlConfigInfoGetApiResponse = 
/** status 200 Successful Response */ SamlConfigInfoResponse;
export type GetSmalConfigInfoApiV1SamlConfigInfoGetApiArg = {
    client?: string;
    skipCsrf?: boolean;
    internal?: any;
};
export type GetClientSamlConfigsApiV1SamlConfigsPilotClientIdGetApiResponse = 
/** status 200 Successful Response */ SamlConfigsResponseRead;
export type GetClientSamlConfigsApiV1SamlConfigsPilotClientIdGetApiArg = {
    pilotClientId: number;
    skipCsrf?: boolean;
    internal?: any;
};
export type GetClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGetApiResponse = 
/** status 200 Successful Response */ SamlConfigResponse;
export type GetClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGetApiArg = {
    pilotClientId: number;
    configUuid: string;
    skipCsrf?: boolean;
    internal?: any;
};
export type CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPutApiResponse = 
/** status 200 Successful Response */ any;
export type CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPutApiArg = {
    pilotClientId: number;
    configUuid: string | null;
    skipCsrf?: boolean;
    internal?: any;
    createSamlConfigRequest: CreateSamlConfigRequest;
};
export type DeleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDeleteApiResponse = 
/** status 200 Successful Response */ any;
export type DeleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDeleteApiArg = {
    pilotClientId: number;
    configUuid: string;
    skipCsrf?: boolean;
    internal?: any;
};
export type CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPostApiResponse = 
/** status 200 Successful Response */ any;
export type CreateOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPostApiArg = {
    pilotClientId: number;
    configUuid?: string | null;
    skipCsrf?: boolean;
    internal?: any;
    createSamlConfigRequest: CreateSamlConfigRequest;
};
export type CsrfTokenApiV1TokenCsrfGetApiResponse = 
/** status 200 Successful Response */ GetCsrfTokenResponse;
export type CsrfTokenApiV1TokenCsrfGetApiArg = {
    sessionJwt?: string | null;
    sessionToken?: string | null;
};
export type TokenVerifyApiV1TokenVerifyPostApiResponse = 
/** status 200 Successful Response */ UserDataModel;
export type TokenVerifyApiV1TokenVerifyPostApiArg = {
    "x-csrftoken"?: string | null;
    tokenVerifyRequest: TokenVerifyRequest;
};
export type TokenRefreshApiV1TokenRefreshPostApiResponse = 
/** status 200 Successful Response */ any;
export type TokenRefreshApiV1TokenRefreshPostApiArg = {
    sessionToken?: string | null;
};
export type GetSelfApiV1UserSelfGetApiResponse = 
/** status 200 Successful Response */ GetUsersResponseRead;
export type GetSelfApiV1UserSelfGetApiArg = {
    skipCsrf?: boolean;
};
export type GetClientUsersApiV1UserGetApiResponse = 
/** status 200 Successful Response */ GetUsersResponseRead;
export type GetClientUsersApiV1UserGetApiArg = {
    uuid?: {
        ""?: string[];
    };
    id?: {
        ""?: number[];
    };
    email?: {
        ""?: string[];
    };
    status?: {
        ""?: UserStatus[];
    };
    roles?: {
        ""?: string[];
    };
    departments?: {
        ""?: number[];
    };
    searchValue?: string;
    limit?: number;
    offset?: number;
    clientId?: number;
    skipCsrf?: boolean;
};
export type CreateUserApiV1UserCreatePostApiResponse = 
/** status 200 Successful Response */ CreateOrUpdateUserResponse;
export type CreateUserApiV1UserCreatePostApiArg = {
    skipCsrf?: boolean;
    internal?: any;
    createOrUpdateUserRequest: CreateOrUpdateUserRequest;
};
export type UpdateUserApiV1UserPilotUserIdPutApiResponse = 
/** status 200 Successful Response */ CreateOrUpdateUserResponse;
export type UpdateUserApiV1UserPilotUserIdPutApiArg = {
    pilotUserId: number;
    skipCsrf?: boolean;
    internal?: any;
    createOrUpdateUserRequest: CreateOrUpdateUserRequest;
};
export type DeleteUserApiV1UserDeleteUserIdDeleteApiResponse = 
/** status 200 Successful Response */ any;
export type DeleteUserApiV1UserDeleteUserIdDeleteApiArg = {
    userId: string | number;
    skipCsrf?: boolean;
    internal?: any;
};
export type SendInviteUserApiV1UserSendInviteUserIdPatchApiResponse = 
/** status 200 Successful Response */ any;
export type SendInviteUserApiV1UserSendInviteUserIdPatchApiArg = {
    userId: string | number;
    skipCsrf?: boolean;
    internal?: any;
};
export type RestoreUserApiV1UserRestoreUserIdPatchApiResponse = 
/** status 200 Successful Response */ any;
export type RestoreUserApiV1UserRestoreUserIdPatchApiArg = {
    userId: string | number;
    skipCsrf?: boolean;
    internal?: any;
};
export type UpdateWorkdayUserApiV1UserWorkdayUserIdPutApiResponse = 
/** status 200 Successful Response */ any;
export type UpdateWorkdayUserApiV1UserWorkdayUserIdPutApiArg = {
    userId: string | number;
    skipCsrf?: boolean;
    internal?: any;
    updateWorkdayUserRequest: UpdateWorkdayUserRequest;
};
export type UpdateWorkdayUserApiV1UserExternalUserIdPutApiResponse = 
/** status 200 Successful Response */ any;
export type UpdateWorkdayUserApiV1UserExternalUserIdPutApiArg = {
    userId: string | number;
    skipCsrf?: boolean;
    internal?: any;
    updateWorkdayUserRequest: UpdateWorkdayUserRequest;
};
export type GetPreferenceApiV1UserPreferencesContextKeyGetApiResponse = 
/** status 200 Successful Response */ UserPreferenceResponse | /** status 204 Nothing is set — an empty successful read, with no body. */ void;
export type GetPreferenceApiV1UserPreferencesContextKeyGetApiArg = {
    context: PreferenceContext;
    key: string;
    skipCsrf?: boolean;
};
export type SetPreferenceApiV1UserPreferencesContextKeyPutApiResponse = 
/** status 204 Successful Response */ void;
export type SetPreferenceApiV1UserPreferencesContextKeyPutApiArg = {
    context: PreferenceContext;
    key: string;
    skipCsrf?: boolean;
    internal?: any;
    setUserPreferenceRequest: SetUserPreferenceRequest;
};
export type ListPreferencesApiV1UserPreferencesContextGetApiResponse = 
/** status 200 Successful Response */ UserPreferenceResponse | /** status 204 Nothing is set — an empty successful read, with no body. */ void;
export type ListPreferencesApiV1UserPreferencesContextGetApiArg = {
    context: PreferenceContext;
    skipCsrf?: boolean;
};
export type OpenidConfigurationWellKnownOpenidConfigurationGetApiResponse = 
/** status 200 Successful Response */ any;
export type OpenidConfigurationWellKnownOpenidConfigurationGetApiArg = void;
export type SessionJwksWellKnownJwksJsonGetApiResponse = 
/** status 200 Successful Response */ any;
export type SessionJwksWellKnownJwksJsonGetApiArg = void;
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type ServiceDataDeletionStatus = "pending" | "in_progress" | "success" | "error" | "deletion_complete" | "error_message_sent" | "s3_policy_created";
export type ClientDeletionQueuedResponse = {
    client_id: number;
    name: string;
    bucket: string;
    domain: string;
    status: ServiceDataDeletionStatus;
    request_sent_at: string;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type QueueClientDeletionRequest = {
    client_id: number;
    bucket: string;
};
export type ClientDeletionCancelledResponse = {
    client_id: number;
    status?: string;
};
export type UserManagement = "workday" | "evisort";
export type AuthenticationProvider = "workday" | "evisort";
export type ClientMapping = {
    uuid?: string;
    client_id: number;
    client_subdomain: string;
    client_name: string;
    customer_billing_id?: string | null;
    user_management: UserManagement;
    authentication_provider: AuthenticationProvider;
    tenant_id?: string | null;
    tenant_environment?: string | null;
    suv_id?: string | null;
    cps_host?: string | null;
    wss_host?: string | null;
    galahad_host?: string | null;
    homepage_host?: string | null;
    config_refreshed_at?: string | null;
    stytch_organization_id?: string | null;
};
export type WorkdayEnvironment = "suv" | "WD5-SVT-INT" | "WD5-SVT" | "WD11-SVT-TRUNK" | "WD500-SVT" | "WD500-SVT-TRUNK" | "WD108-IMPL" | "WD12-IMPL" | "WD99-SALES100" | "WD99-SALES200" | "WD99-SALES300" | "WD12-PROD" | "WD5-IMPL" | "WD5-PROD" | "WD2-IMPL" | "WD3-IMPL" | "WD1-PROD" | "WD3-PROD" | "WD103-PROD" | "WD105-IMPL" | "WD105-PROD" | "WD108-PROD" | "WD117-IMPL" | "WD501-IMPL" | "WD501-PROD" | "WD502-PROD" | "WD503-IMPL" | "WD503-PROD";
export type WorkdayEnvironmentNode = {
    environment: WorkdayEnvironment;
    cps_host?: string | null;
    wss_host?: string | null;
    galahad_host?: string | null;
    homepage_host?: string | null;
};
export type CpsFuguRegistrationResult = {
    detail?: string;
};
export type OAuthClientCreateResponse = {
    uuid: string;
    oauth_client_id: string;
    oauth_client_name: string;
    pilot_client_id: number;
    oauth_client_type: string;
    redirect_uris: string[];
    allowed_grant_types: string[];
    allowed_scopes: string[];
    token_endpoint_auth_method: string;
    is_active: boolean;
    oauth_client_secret: string;
};
export type OAuthClientCreateRequest = {
    oauth_client_name: string;
    redirect_uris: string[];
    allowed_grant_types?: string[];
    allowed_scopes?: string[];
    oauth_client_type?: string;
    token_endpoint_auth_method?: string;
};
export type OAuthClientResponse = {
    uuid: string;
    oauth_client_id: string;
    oauth_client_name: string;
    pilot_client_id: number;
    oauth_client_type: string;
    redirect_uris: string[];
    allowed_grant_types: string[];
    allowed_scopes: string[];
    token_endpoint_auth_method: string;
    is_active: boolean;
};
export type OAuthClientUpdateRequest = {
    oauth_client_name?: string | null;
    redirect_uris?: string[] | null;
    allowed_scopes?: string[] | null;
};
export type SsoRegistration = {
    connection_id: string;
    external_id: string;
    registration_id: string;
    sso_attributes?: {
        [key: string]: any;
    } | null;
};
export type OAuthRegistration = {
    provider_type: string;
    provider_subject: string;
    member_oauth_registration_id: string;
    profile_picture_url?: string | null;
    locale?: string | null;
};
export type RetiredEmail = {
    email_id: string;
    email_address: string;
};
export type MemberRoleSource = {
    type: string;
    details?: {
        [key: string]: any;
    } | null;
};
export type MemberRole = {
    role_id: string;
    sources: MemberRoleSource[];
};
export type Group = {
    value: string;
    display: string;
};
export type Email = {
    value: string;
    type: string;
    primary: boolean;
};
export type PhoneNumber = {
    value: string;
    type: string;
    primary: boolean;
};
export type Address = {
    formatted: string;
    street_address: string;
    locality: string;
    region: string;
    postal_code: string;
    country: string;
    type: string;
    primary: boolean;
};
export type IMs = {
    value: string;
    type: string;
    primary: boolean;
};
export type Photo = {
    value: string;
    type: string;
    primary: boolean;
};
export type Entitlement = {
    value: string;
    type: string;
    primary: boolean;
};
export type Role = {
    value: string;
    type: string;
    primary: boolean;
};
export type X509Certificate = {
    value: string;
    type: string;
    primary: boolean;
};
export type Name = {
    formatted: string;
    family_name: string;
    given_name: string;
    middle_name: string;
    honorific_prefix: string;
    honorific_suffix: string;
};
export type Manager = {
    value: string;
    ref: string;
    display_name: string;
};
export type EnterpriseExtension = {
    employee_number: string;
    cost_center: string;
    division: string;
    department: string;
    organization: string;
    manager?: Manager | null;
};
export type ScimAttributes = {
    user_name: string;
    id: string;
    external_id: string;
    active: boolean;
    groups: Group[];
    display_name: string;
    nick_name: string;
    profile_url: string;
    user_type: string;
    title: string;
    preferred_language: string;
    locale: string;
    timezone: string;
    emails: Email[];
    phone_numbers: PhoneNumber[];
    addresses: Address[];
    ims: IMs[];
    photos: Photo[];
    entitlements: Entitlement[];
    roles: Role[];
    x509certificates: X509Certificate[];
    name?: Name | null;
    enterprise_extension?: EnterpriseExtension | null;
};
export type ScimRegistration = {
    connection_id: string;
    registration_id: string;
    external_id?: string | null;
    scim_attributes?: ScimAttributes | null;
};
export type Member = {
    organization_id: string;
    member_id: string;
    email_address: string;
    status: string;
    name: string;
    sso_registrations: SsoRegistration[];
    is_breakglass: boolean;
    member_password_id: string;
    oauth_registrations: OAuthRegistration[];
    email_address_verified: boolean;
    mfa_phone_number_verified: boolean;
    is_admin: boolean;
    totp_registration_id: string;
    retired_email_addresses: RetiredEmail[];
    is_locked: boolean;
    mfa_enrolled: boolean;
    mfa_phone_number: string;
    default_mfa_method: string;
    roles: MemberRole[];
    trusted_metadata?: {
        [key: string]: any;
    } | null;
    untrusted_metadata?: {
        [key: string]: any;
    } | null;
    created_at?: string | null;
    updated_at?: string | null;
    scim_registration?: ScimRegistration | null;
    external_id?: string | null;
    lock_created_at?: string | null;
    lock_expires_at?: string | null;
};
export type ActiveSsoConnection = {
    connection_id: string;
    display_name: string;
    identity_provider: string;
};
export type EmailImplicitRoleAssignment = {
    domain: string;
    role_id: string;
};
export type CustomRolePermission = {
    resource_id: string;
    actions: string[];
};
export type CustomRole = {
    role_id: string;
    description: string;
    permissions: CustomRolePermission[];
};
export type ActiveScimConnection = {
    connection_id: string;
    display_name: string;
    bearer_token_last_four: string;
    bearer_token_expires_at?: string | null;
};
export type Organization = {
    organization_id: string;
    organization_name: string;
    organization_logo_url: string;
    organization_slug: string;
    sso_jit_provisioning: string;
    sso_jit_provisioning_allowed_connections: string[];
    sso_active_connections: ActiveSsoConnection[];
    email_allowed_domains: string[];
    email_jit_provisioning: string;
    email_invites: string;
    auth_methods: string;
    allowed_auth_methods: string[];
    mfa_policy: string;
    rbac_email_implicit_role_assignments: EmailImplicitRoleAssignment[];
    mfa_methods: string;
    allowed_mfa_methods: string[];
    oauth_tenant_jit_provisioning: string;
    claimed_email_domains: string[];
    first_party_connected_apps_allowed_type: string;
    allowed_first_party_connected_apps: string[];
    third_party_connected_apps_allowed_type: string;
    allowed_third_party_connected_apps: string[];
    custom_roles: CustomRole[];
    trusted_metadata?: {
        [key: string]: any;
    } | null;
    created_at?: string | null;
    updated_at?: string | null;
    organization_external_id?: string | null;
    sso_default_connection_id?: string | null;
    scim_active_connection?: ActiveScimConnection | null;
    allowed_oauth_tenants?: {
        [key: string]: any;
    } | null;
};
export type AuthenticationFactorType = "magic_link" | "otp" | "oauth" | "webauthn" | "totp" | "crypto" | "password" | "signature_challenge" | "sso" | "imported" | "recovery_codes" | "email_otp" | "impersonated" | "trusted_auth_token";
export type AuthenticationFactorDeliveryMethod = "email" | "sms" | "whatsapp" | "embedded" | "oauth_google" | "oauth_microsoft" | "oauth_apple" | "webauthn_registration" | "authenticator_app" | "oauth_github" | "recovery_code" | "oauth_facebook" | "crypto_wallet" | "oauth_amazon" | "oauth_bitbucket" | "oauth_coinbase" | "oauth_discord" | "oauth_figma" | "oauth_gitlab" | "oauth_instagram" | "oauth_linkedin" | "oauth_shopify" | "oauth_slack" | "oauth_snapchat" | "oauth_spotify" | "oauth_steam" | "oauth_tiktok" | "oauth_twitch" | "oauth_twitter" | "knowledge" | "biometric" | "sso_saml" | "sso_oidc" | "oauth_salesforce" | "oauth_yahoo" | "oauth_hubspot" | "imported_auth0" | "oauth_exchange_slack" | "oauth_exchange_hubspot" | "oauth_exchange_github" | "oauth_exchange_google" | "impersonation" | "oauth_access_token_exchange" | "trusted_token_exchange";
export type EmailFactor = {
    email_id: string;
    email_address: string;
};
export type PhoneNumberFactor = {
    phone_id: string;
    phone_number: string;
};
export type GoogleOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type MicrosoftOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type AppleOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type WebAuthnFactor = {
    webauthn_registration_id: string;
    domain: string;
    user_agent?: string | null;
};
export type AuthenticatorAppFactor = {
    totp_id: string;
};
export type GithubOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type RecoveryCodeFactor = {
    totp_recovery_code_id: string;
};
export type FacebookOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type CryptoWalletFactor = {
    crypto_wallet_id: string;
    crypto_wallet_address: string;
    crypto_wallet_type: string;
};
export type AmazonOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type BitbucketOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type CoinbaseOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type DiscordOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type FigmaOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type GitLabOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type InstagramOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type LinkedInOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type ShopifyOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type SlackOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type SnapchatOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type SpotifyOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type SteamOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type TikTokOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type TwitchOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type TwitterOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type EmbeddableMagicLinkFactor = {
    embedded_id: string;
};
export type BiometricFactor = {
    biometric_registration_id: string;
};
export type SamlssoFactor = {
    id: string;
    provider_id: string;
    external_id: string;
};
export type OidcssoFactor = {
    id: string;
    provider_id: string;
    external_id: string;
};
export type SalesforceOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type YahooOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type HubspotOAuthFactor = {
    id: string;
    provider_subject: string;
    email_id?: string | null;
};
export type SlackOAuthExchangeFactor = {
    email_id: string;
};
export type HubspotOAuthExchangeFactor = {
    email_id: string;
};
export type GithubOAuthExchangeFactor = {
    email_id: string;
};
export type GoogleOAuthExchangeFactor = {
    email_id: string;
};
export type ImpersonatedFactor = {
    impersonator_id: string;
    impersonator_email_address: string;
};
export type OAuthAccessTokenExchangeFactor = {
    client_id: string;
};
export type TrustedAuthTokenFactor = {
    token_id: string;
};
export type AuthenticationFactor = {
    type: AuthenticationFactorType;
    delivery_method: AuthenticationFactorDeliveryMethod;
    last_authenticated_at?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    email_factor?: EmailFactor | null;
    phone_number_factor?: PhoneNumberFactor | null;
    google_oauth_factor?: GoogleOAuthFactor | null;
    microsoft_oauth_factor?: MicrosoftOAuthFactor | null;
    apple_oauth_factor?: AppleOAuthFactor | null;
    webauthn_factor?: WebAuthnFactor | null;
    authenticator_app_factor?: AuthenticatorAppFactor | null;
    github_oauth_factor?: GithubOAuthFactor | null;
    recovery_code_factor?: RecoveryCodeFactor | null;
    facebook_oauth_factor?: FacebookOAuthFactor | null;
    crypto_wallet_factor?: CryptoWalletFactor | null;
    amazon_oauth_factor?: AmazonOAuthFactor | null;
    bitbucket_oauth_factor?: BitbucketOAuthFactor | null;
    coinbase_oauth_factor?: CoinbaseOAuthFactor | null;
    discord_oauth_factor?: DiscordOAuthFactor | null;
    figma_oauth_factor?: FigmaOAuthFactor | null;
    git_lab_oauth_factor?: GitLabOAuthFactor | null;
    instagram_oauth_factor?: InstagramOAuthFactor | null;
    linked_in_oauth_factor?: LinkedInOAuthFactor | null;
    shopify_oauth_factor?: ShopifyOAuthFactor | null;
    slack_oauth_factor?: SlackOAuthFactor | null;
    snapchat_oauth_factor?: SnapchatOAuthFactor | null;
    spotify_oauth_factor?: SpotifyOAuthFactor | null;
    steam_oauth_factor?: SteamOAuthFactor | null;
    tik_tok_oauth_factor?: TikTokOAuthFactor | null;
    twitch_oauth_factor?: TwitchOAuthFactor | null;
    twitter_oauth_factor?: TwitterOAuthFactor | null;
    embeddable_magic_link_factor?: EmbeddableMagicLinkFactor | null;
    biometric_factor?: BiometricFactor | null;
    saml_sso_factor?: SamlssoFactor | null;
    oidc_sso_factor?: OidcssoFactor | null;
    salesforce_oauth_factor?: SalesforceOAuthFactor | null;
    yahoo_oauth_factor?: YahooOAuthFactor | null;
    hubspot_oauth_factor?: HubspotOAuthFactor | null;
    slack_oauth_exchange_factor?: SlackOAuthExchangeFactor | null;
    hubspot_oauth_exchange_factor?: HubspotOAuthExchangeFactor | null;
    github_oauth_exchange_factor?: GithubOAuthExchangeFactor | null;
    google_oauth_exchange_factor?: GoogleOAuthExchangeFactor | null;
    impersonated_factor?: ImpersonatedFactor | null;
    oauth_access_token_exchange_factor?: OAuthAccessTokenExchangeFactor | null;
    trusted_auth_token_factor?: TrustedAuthTokenFactor | null;
};
export type MemberSession = {
    member_session_id: string;
    member_id: string;
    started_at: string;
    last_accessed_at: string;
    expires_at: string;
    authentication_factors: AuthenticationFactor[];
    organization_id: string;
    roles: string[];
    organization_slug: string;
    custom_claims?: {
        [key: string]: any;
    } | null;
};
export type MemberOptions = {
    mfa_phone_number: string;
    totp_registration_id: string;
};
export type MfaRequired = {
    member_options?: MemberOptions | null;
    secondary_auth_initiated?: string | null;
};
export type PrimaryRequired = {
    allowed_auth_methods: string[];
};
export type DeviceAttributeDetails = {
    is_new: boolean;
    first_seen_at?: string | null;
    last_seen_at?: string | null;
};
export type DeviceInfo = {
    visitor_id: string;
    visitor_id_details?: DeviceAttributeDetails | null;
    ip_address?: string | null;
    ip_address_details?: DeviceAttributeDetails | null;
    ip_geo_city?: string | null;
    ip_geo_region?: string | null;
    ip_geo_country?: string | null;
    ip_geo_country_details?: DeviceAttributeDetails | null;
};
export type AuthenticateResponse = {
    status_code: number;
    request_id: string;
    member_id: string;
    organization_id: string;
    member: Member;
    session_token: string;
    session_jwt: string;
    organization: Organization;
    intermediate_session_token: string;
    member_authenticated: boolean;
    member_session?: MemberSession | null;
    mfa_required?: MfaRequired | null;
    primary_required?: PrimaryRequired | null;
    member_device?: DeviceInfo | null;
};
export type PasswordLoginRequest = {
    email_address: string;
    organization_id: string;
    password: string;
    session_duration_minutes?: number;
};
export type StytchTokenType = "magic_link" | "multi_tenant_magic_links" | "reset_password" | "multi_tenant_passwords" | "login" | "sso" | "oauth" | "discovery" | "discovery_oauth";
export type PasswordSetRequest = {
    first_name?: string | null;
    last_name?: string | null;
    job_title?: string | null;
    new_password: string;
};
export type ClientAuthConfigsResponse = {
    signin_enabled: boolean;
    password_signin_enabled?: boolean;
    sso_signin_enabled?: boolean;
    oauth_signin_enabled?: boolean;
    oidc_signin_enabled?: boolean;
};
export type BodyPusherAuthApiV1PusherAuthPost = {
    channel_name: string;
    socket_id: string;
    join_type?: string | null;
};
export type SamlConfigInfoResponse = {
    acs_url: string;
    audience_uri: string;
};
export type AuthContextClass = "password_protected_transport" | "x509" | "password" | "unspecified" | "tls_client" | "kerberos";
export type CustomAttributeMapType = "static" | "custom";
export type SamlCustomAttributeMapFields = {
    evisort_static_attr?: string | null;
    evisort_custom_attr?: string | null;
    saml_attr: string;
    type: CustomAttributeMapType;
};
export type SamlCustomAttributeMap = {
    mappings?: SamlCustomAttributeMapFields[];
};
export type SamlEnforcementPolicy = "enforce_all" | "enforce_all_non_admin" | "enforce_none" | "enforce_domains";
export type SamlConfigResponse = {
    idp_name: string;
    idp_id: string;
    sso_url: string;
    x509_cert: string;
    idp_metadata_url?: string | null;
    auth_context_class: AuthContextClass[];
    attributes: {
        [key: string]: any;
    };
    custom_attribute_map: SamlCustomAttributeMap;
    default_role?: string | null;
    policy: SamlEnforcementPolicy;
    allowed_domains?: string[];
    is_enabled: boolean;
    id: string;
    sp_id: string;
    date_created: string;
    date_updated: string;
};
export type SamlConfigsResponse = {
    data: SamlConfigResponse[];
};
export type SamlConfigsResponseRead = {
    data: SamlConfigResponse[];
    links: {
        [key: string]: any;
    };
    meta: {
        [key: string]: any;
    };
};
export type SamlCustomAttributeMap2 = {
    mappings?: SamlCustomAttributeMapFields[];
};
export type CreateSamlConfigRequest = {
    idp_name: string;
    idp_id: string;
    sso_url: string;
    x509_cert: string;
    idp_metadata_url?: string | null;
    auth_context_class: AuthContextClass[];
    attributes: {
        [key: string]: any;
    };
    custom_attribute_map: SamlCustomAttributeMap2;
    default_role?: string | null;
    policy: SamlEnforcementPolicy;
    allowed_domains?: string[];
    is_enabled: boolean;
};
export type GetCsrfTokenResponse = {
    csrf_token: string;
};
export type UserDataModel = {
    type?: string;
    id: string;
    attributes: {
        [key: string]: any;
    };
};
export type TokenVerifyRequest = {
    session_jwt: string;
};
export type GetUsersResponse = {
    data: UserDataModel[];
};
export type GetUsersResponseRead = {
    data: UserDataModel[];
    links: {
        [key: string]: any;
    };
    meta: {
        [key: string]: any;
    };
};
export type UserStatus = "Active" | "Pending" | "Deactivated";
export type PilotUserAttributes = {
    client: number;
    departments?: number[];
    role_id?: number | null;
    email: string;
    role_uuid: string;
    first_name: string;
    last_name: string;
    job_title?: string | null;
    [key: string]: any;
};
export type CreateOrUpdateUserResponseData = {
    id: number | string;
    type?: string;
    attributes: PilotUserAttributes;
    [key: string]: any;
};
export type CreateOrUpdateUserResponse = {
    data: CreateOrUpdateUserResponseData;
};
export type CreateOrUpdateUserRequestData = {
    attributes: PilotUserAttributes;
};
export type CreateOrUpdateUserRequest = {
    data: CreateOrUpdateUserRequestData;
};
export type UpdateWorkdayUserRequest = {
    role_uuid: string;
    pilot_department_ids: number[];
};
export type JsonValueOutput = string | number | number | boolean | {
    [key: string]: JsonValueOutput;
} | JsonValueOutput[] | null;
export type UserPreferenceResponse = {
    type?: string;
    attributes: {
        [key: string]: JsonValueOutput;
    };
};
export type PreferenceContext = "FOLDER" | "SEARCH" | "GROUP" | "EVISEARCH_FOLDER" | "EVISEARCH_SEARCH" | "EVISEARCH_GROUP" | "GLOBAL";
export type JsonValueInput = string | number | number | boolean | {
    [key: string]: JsonValueInput;
} | JsonValueInput[] | null;
export type SetPreferenceAttributes = {
    value: JsonValueInput;
};
export type SetUserPreferenceRequest = {
    type?: string;
    attributes: SetPreferenceAttributes;
};
